import { render } from "./ModalPostArticle.vue?vue&type=template&id=059ae136&scoped=true"
import script from "./ModalPostArticle.vue?vue&type=script&lang=js"
export * from "./ModalPostArticle.vue?vue&type=script&lang=js"

import "./ModalPostArticle.vue?vue&type=style&index=0&id=059ae136&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059ae136"]])

export default __exports__